var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Thêm mẫu điểm danh",
        visible: _vm.dialogVisible,
        width: "50%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "newAttendanceSample",
          attrs: {
            "label-width": "120px",
            model: _vm.newAttendanceSample,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Loại điểm danh", prop: "attendanceType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Chọn loại điểm danh", clearable: "" },
                  model: {
                    value: _vm.newAttendanceSample.attendanceType,
                    callback: function ($$v) {
                      _vm.$set(_vm.newAttendanceSample, "attendanceType", $$v)
                    },
                    expression: "newAttendanceSample.attendanceType",
                  },
                },
                _vm._l(_vm.attendanceTypeList, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { value: item.key, label: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Nội dung", prop: "attendanceContent" } },
            [
              _c("el-input", {
                attrs: {
                  rows: 5,
                  type: "textarea",
                  placeholder: "Nhập nội dung",
                },
                model: {
                  value: _vm.newAttendanceSample.attendanceContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.newAttendanceSample, "attendanceContent", $$v)
                  },
                  expression: "newAttendanceSample.attendanceContent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("newAttendanceSample")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm("newAttendanceSample")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }